import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, rp } from "@/lib/api";

export default function MarginReport() {
  const [d, setD] = useState(null);
  const [month, setMonth] = useState("");
  useEffect(() => { api.get("/reports/delivery-margin", { params: { month: month || undefined } }).then((r) => setD(r.data)); }, [month]);
  if (!d) return <div className="text-ink-soft">Loading…</div>;

  return (
    <div data-testid="admin-margin-report">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-3xl tracking-tight">Delivery Margin</h1>
          <p className="text-sm text-ink-soft mt-1">What you charged customers vs what delivery actually cost you.</p>
        </div>
        <input data-testid="margin-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)}
          className="h-10 rounded-md border border-input bg-white px-3 text-sm" />
      </div>

      <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-3">
        {[["Charged to Customers", rp(d.charged_total), "margin-charged"],
          ["Actual Delivery Cost", rp(d.cost_total), "margin-cost"],
          ["Margin", rp(d.margin_total), "margin-total"],
          ["Bookings Missing Cost", d.missing_cost, "margin-missing"]].map(([l, v, tid]) => (
          <div key={l} className="bg-white border border-black/10 rounded-lg p-4" data-testid={tid}>
            <div className="text-[10px] uppercase tracking-widest text-ink-soft">{l}</div>
            <div className={`mt-1.5 text-xl font-semibold ${tid === "margin-total" && d.margin_total < 0 ? "text-lm-red" : ""}`}>{v}</div>
          </div>
        ))}
      </div>

      {d.missing_cost > 0 && (
        <p className="mt-4 text-xs text-ink-soft">Tip: record the real Lalamove/Grab cost in each booking's "Actual Delivery Cost" field to make this report accurate.</p>
      )}

      <h2 className="mt-8 text-base md:text-lg font-semibold">By Month</h2>
      <div className="mt-3 overflow-x-auto bg-white border border-black/10 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
            <tr><th className="p-3">Month</th><th className="p-3">Deliveries</th><th className="p-3">Charged</th><th className="p-3">Cost</th><th className="p-3">Margin</th></tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {d.by_month.map((m) => (
              <tr key={m.month} data-testid={`margin-month-${m.month}`}>
                <td className="p-3">{m.month}</td><td className="p-3">{m.bookings}</td>
                <td className="p-3">{rp(m.charged)}</td><td className="p-3">{rp(m.cost)}</td>
                <td className={`p-3 font-semibold ${m.margin < 0 ? "text-lm-red" : "text-emerald-700"}`}>{rp(m.margin)}</td>
              </tr>
            ))}
            {d.by_month.length === 0 && <tr><td colSpan={5} className="p-5 text-ink-soft">No deliveries yet.</td></tr>}
          </tbody>
        </table>
      </div>

      <h2 className="mt-8 text-base md:text-lg font-semibold">Per Booking</h2>
      <div className="mt-3 overflow-x-auto bg-white border border-black/10 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
            <tr><th className="p-3">Date</th><th className="p-3">Booking</th><th className="p-3">Area</th><th className="p-3">Vehicle</th>
              <th className="p-3">Charged</th><th className="p-3">Cost</th><th className="p-3">Margin</th></tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {d.bookings.map((b) => (
              <tr key={b.id} data-testid={`margin-row-${b.booking_code}`}>
                <td className="p-3 whitespace-nowrap">{b.rental_date}</td>
                <td className="p-3"><Link className="text-lm-red hover:underline" to={`/admin/bookings/${b.id}`}>{b.booking_code}</Link>
                  <div className="text-xs text-ink-soft">{b.customer_name}</div></td>
                <td className="p-3">{b.area || "—"}</td>
                <td className="p-3">{b.vehicle_type === "bike" ? "Bike" : b.vehicle_type === "car" ? "Car" : "—"}</td>
                <td className="p-3">{rp(b.charged)}</td>
                <td className="p-3">{b.cost_recorded ? rp(b.cost) : <span className="text-amber-700 text-xs">not recorded</span>}</td>
                <td className={`p-3 font-semibold ${b.margin < 0 ? "text-lm-red" : ""}`}>{rp(b.margin)}</td>
              </tr>
            ))}
            {d.bookings.length === 0 && <tr><td colSpan={7} className="p-5 text-ink-soft">No delivery bookings yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
